import { DocumentPageIdentityData } from 'src/front/api/generated';

import { IdentityFormData } from 'src/front/components/identity/IdentityFormData';
import uid from 'uid';
import { convertStringToDate, formatDate } from './dateTimeUtils';
import { dictionaryLineFormat, optionFormat } from './formUtils';

export interface Identity extends IdentityFormData {
  isNew?: boolean;
  isActive?: boolean;
  givenCountry?: string;
}

export const createDocumentPageDataForValidation = (
  identityList: Identity[]
): DocumentPageIdentityData[] => {
  return identityList.map((identity) => ({
    ...(identity.isNew ? {} : { customerIdentityId: identity.id }),
    identityType: dictionaryLineFormat(identity.identityType),
    identityDocumentSerialCode: identity.identityDocumentSerialCode,
    identityDocumentSerialNumber: identity.identityDocumentSerialNumber,
    issueDate: formatDate(identity.issueDate),
    expireDate: formatDate(identity.expireDate),
    issuedBy: identity.issuedBy,
    ...(identity.issueCountry ? { issueCountry: dictionaryLineFormat(identity.issueCountry) } : {}),
    unitCode: identity.unitCode,
    isNew: identity.isNew,
    isActive: identity.isActive,
  }));
};
export const convertDocumentPageIdentityDataToIdentity = (
  pageIdentityList?: DocumentPageIdentityData[]
): Identity[] => {
  return (
    pageIdentityList?.map((identity) => ({
      id: identity.customerIdentityId || uid(),
      identityType: optionFormat(identity.identityType),
      identityDocumentSerialCode: identity.identityDocumentSerialCode || '',
      identityDocumentSerialNumber: identity.identityDocumentSerialNumber || '',
      issueDate: convertStringToDate(identity.issueDate),
      expireDate: convertStringToDate(identity.expireDate),
      issuedBy: identity.issuedBy || '',
      issueCountry: identity.issueCountry ? optionFormat(identity.issueCountry) : null,
      unitCode: identity.unitCode || '',
      isNew: identity.isNew,
      isActive: identity.isActive,
    })) || []
  );
};
